import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const notEmptyValidationRuleResolver: BaseValidationRuleResolver = (value) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
  return isEmpty ? 'Required' : null;
};
